// TODO - переделать нв TS Надо данный Store.
// начал делать новый: './offices/partnerOfficeStore.ts'
// Данный store не рекомендуется расширять

import { action, observable } from 'mobx';
import controller from './controller';

const officeStore = observable({
  photos: [],
  error: null,
  insurancesByServiceOffice: [], // список страховых компаний,  с которыми работает партнёр в указанном и офисе ( по serviceOfficeId )
  insurances_ServiceOfficeId: undefined, // ServiceOfficeId, по которому лежат данные в insurancesByServiceOffice
  loadingInsuranceByServiceOffice: false, // признак, что insurancesByServiceOffice загружается с сервера
  officeServices: [], // сервисы по офису
  officeServicesOfficeId: [], // officeId, по которому лежат данные в officeServices
  officeService: {}, // сервисы по офису
  officeServiceById: null, // officeServiceId, по которому лежат данные в officeService
});

const officeActions = {
  getPhotos: action(async (officeId) => {
    const response = await controller.getPartnerOfficePhotos(officeId);
    if (response.errorData) {
      officeStore.error = response.errorData;
    }
    officeStore.photos = response.data;
  }),
  addPartnerOfficePhotos: action(async (data) => {
    const response = await controller.addPartnerOfficePhotos(data);
    if (response.errorData) {
      officeStore.error = response.errorData;
    }
  }),
  updatePartnerOfficePhoto: action(async (data) => {
    const response = await controller.updatePartnerOfficePhoto(data);
    if (response.errorData) {
      officeStore.error = response.errorData;
    }
  }),
  deletePartnerOfficePhoto: action(async (data) => {
    const response = await controller.deletePartnerOfficePhoto(data);
    if (response.errorData) {
      officeStore.error = response.errorData;
    }
  }),

  getPartnerInsuranceByServiceOffice: action(async (serviceOfficeId) => {
    officeStore.loadingInsuranceByServiceOffice = false;
    const response = await controller.getPartnerInsuranceByServiceOfficeId(serviceOfficeId);
    if (response.errorData) {
      officeStore.error = response.errorData;
      officeStore.insurancesByServiceOffice = [];
    } else {
      officeStore.insurancesByServiceOffice = response.data;
      officeStore.insurances_ServiceOfficeId = serviceOfficeId;
    }
    officeStore.loadingInsuranceByServiceOffice = false;
  }),

  addPartnerInsuranceByServiceOffice: action(async (data) => {
    const response = await controller.createPartnerInsurance(data);
    if (response.errorData) {
      officeStore.error = response.errorData;
    }
  }),

  deletePartnerInsuranceByServiceOffice: action(async (data) => {
    const response = await controller.deletePartnerInsurance(data);
    if (response.errorData) {
      officeStore.error = response.errorData;
    }
  }),

  clearInsuranceByServiceOffice: action(async () => {
    officeStore.loadingInsuranceByServiceOffice = false;
    officeStore.insurancesByServiceOffice = [];
    officeStore.insurances_ServiceOfficeId = undefined;
  }),

  getOfficeServices: action(async (officeId) => {
    const response = await controller.getPartnerOfficeServices(officeId);
    if (response.errorData) {
      officeStore.error = response.errorData;
    }
    officeStore.officeServices = response.data;
    officeStore.officeServicesOfficeId = officeId;
  }),

  getPartnerOfficeService: action(async (officeServiceId) => {
    const response = await controller.getPartnerOfficeService(officeServiceId);
    if (response.errorData) {
      officeStore.error = response.errorData;
    }
    officeStore.officeService = response.data;
    officeStore.officeServiceById = officeServiceId;
  }),

  updatePartnerOfficeService: action(async (data) => {
    const response = await controller.updatePartnerOfficeService(data);
    if (response.errorData) {
      officeStore.error = response.errorData;
    }
    officeStore.officeService = response.data;
    officeStore.officeServiceById = data?.id;
  }),

};

export { officeStore, officeActions };
